import { FieldPolicy } from '@apollo/client';



export type ITypeSpecificPolicy<T> = {
  fields: Partial<Record<keyof T, FieldPolicy>>;
};



export function formatLargeValue(value: Big) {
  if (value.abs().gte(1_000_000_000)) {
    return value.div(1_000_000_000).toFixed(2) + 'B';
  }
  if (value.abs().gte(1_000_000)) {
    return value.div(1_000_000).toFixed(2) + 'M';
  }

  return value.toNumber().toLocaleString('en-US', {
    useGrouping: true,
    maximumFractionDigits: 0
  });
}
